<template>
  <span class="file-spec"><slot></slot></span>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
@use '../../../../sass/base/_colors.scss' as *;

.file-spec {
  text-align: center;
  display: inline-block;
  padding: 5px 8px;
  margin: 0 10px 7px 0;
  border-radius: 10px;
  background-color: #f3f3f3;
  white-space: nowrap;
  font-weight: 300;
  line-height: 12px;
}

.selected {
  .file-spec {
    background-color: transparent;
  }
}

.spec-title {
  padding-right: 2px;
  font-weight: 500;
}
</style>
